import React, { useEffect, useState, createContext, useContext } from 'react';
export interface SiteContent {
  hero: {
    heading1: string;
    heading2: string;
    subtitle: string;
    ctaBook: string;
    ctaClasses: string;
  };
  about: {
    sectionLabel: string;
    sectionTitle: string;
    sectionSubtitle: string;
    founderName: string;
    founderRole: string;
    founderImage: string;
    bio: string[];
    quote: string;
    badges: string[];
    historyTitle: string;
    historyParagraphs: string[];
    whyTitle: string;
    whyItems: Array<{
      title: string;
      description: string;
    }>;
    missionTitle: string;
    missionText: string;
  };
  classes: {
    sectionLabel: string;
    sectionTitle: string;
    sectionSubtitle: string;
    presencial: {
      title: string;
      description: string;
      singlePrice: string;
      packPrice: string;
      packSavings: string;
    };
    virtual: {
      title: string;
      description: string;
      singlePrice: string;
      packPrice: string;
      packSavings: string;
    };
    privada: {
      title: string;
      description: string;
      singlePrice: string;
      packPrice: string;
      packSavings: string;
    };
  };
  testimonials: {
    sectionLabel: string;
    sectionTitle: string;
    sectionSubtitle: string;
    items: Array<{
      quote: string;
      author: string;
      location: string;
      date: string;
      rating: number;
      verified: boolean;
    }>;
  };
  faq: {
    sectionLabel: string;
    sectionTitle: string;
    items: Array<{
      q: string;
      a: string;
    }>;
  };
  contact: {
    sectionLabel: string;
    sectionTitle: string;
    sectionSubtitle: string;
    email: string;
    phone: string;
    whatsapp: string;
    hoursWeekday: string;
    hoursWeekend: string;
  };
  footer: {
    description: string;
    copyrightText: string;
  };
}
const defaultContent: SiteContent = {
  hero: {
    heading1: 'Todos tienen tiempo para el estrés.',
    heading2: '¿Y para ti?',
    subtitle: 'Llegas tensa. Sales renovada. 60 minutos de yoga cada fin de semana para todos los niveles. Sin excusas. Sin experiencia previa. Solo empieza.',
    ctaBook: 'Agendar mi clase',
    ctaClasses: 'Ver clases'
  },
  about: {
    sectionLabel: 'Sobre Nosotros',
    sectionTitle: 'Vimutti Yoga',
    sectionSubtitle: 'Un espacio dedicado a tu bienestar y transformación personal',
    founderName: 'Franchelis Vargas',
    founderRole: 'Fundadora e Instructora',
    founderImage: 'https://cdn.magicpatterns.com/uploads/81EuWzkx5S74sN6jcHUA4X/702bfc31-d71b-4ed0-9d0c-132b044f9f22.jpg',
    bio: ['El yoga llegó a mi vida en un momento de búsqueda personal. Como muchos, enfrentaba el estrés y la desconexión que trae la vida moderna. Fue a través de la práctica constante que descubrí no solo paz interior, sino también mi verdadero propósito: compartir esta transformación con otros.', 'Con más de 5 años de experiencia y una sólida formación en diversas escuelas de yoga, he dedicado mi vida a estudiar y perfeccionar mi práctica. Cuento con certificaciones internacionales, además de formación continua en anatomía, meditación y filosofía del yoga.', 'Vimutti Yoga nació de mi deseo de crear un espacio donde cada persona, sin importar su nivel o experiencia, pueda encontrar su propio camino hacia el bienestar. Creo firmemente que el yoga no es solo una práctica física, sino una herramienta poderosa para la transformación personal y el autodescubrimiento.'],
    quote: '"Mi misión es guiarte en tu viaje hacia el equilibrio, la paz interior y el redescubrimiento de tu mejor versión."',
    badges: ['5+ años de experiencia', 'Certificaciones Internacionales', 'Formación Continua'],
    historyTitle: 'Nuestra Historia',
    historyParagraphs: ['Vimutti Yoga nació de la pasión por compartir los beneficios transformadores del yoga. Cada clase está diseñada con dedicación y cuidado, pensando en crear un espacio donde puedas reconectar con tu cuerpo, calmar tu mente y encontrar paz interior.', 'Las clases están diseñadas para todos los niveles, desde principiantes hasta practicantes avanzados. Combinamos técnicas tradicionales con enfoques modernos para crear una experiencia única, personalizada y accesible.'],
    whyTitle: '¿Por qué Vimutti?',
    whyItems: [{
      title: 'Instructora Certificada',
      description: 'Más de 5 años de experiencia y formación internacional continua'
    }, {
      title: 'Ambiente Acogedor',
      description: 'Espacios diseñados para tu comodidad y concentración'
    }, {
      title: 'Flexibilidad Total',
      description: 'Clases presenciales y virtuales que se adaptan a tu vida'
    }, {
      title: 'Atención Personalizada',
      description: 'Grupos pequeños para una guía cercana y efectiva'
    }],
    missionTitle: 'Nuestra Misión',
    missionText: 'Hacer el yoga accesible para todos, creando un puente entre la práctica ancestral y la vida moderna. Mi objetivo es que cada persona descubra su potencial de bienestar, equilibrio y paz interior a través de una práctica consciente y transformadora.'
  },
  classes: {
    sectionLabel: 'Modalidades',
    sectionTitle: '¿Cómo quieres practicar?',
    sectionSubtitle: 'Diseñé cada clase para que salgas con más energía, menos tensión y una mente más clara — sin importar tu nivel.',
    presencial: {
      title: 'Yoga Grupal',
      description: 'Tu reset presencial. Siente la energía del grupo y mi guía directa. 60 min para soltar el estrés, corregir tu postura y recargar el fin de semana.',
      singlePrice: '$1',
      packPrice: '$1',
      packSavings: 'Ahorras $10'
    },
    virtual: {
      title: 'Yoga por Zoom',
      description: 'Misma energía, cero traslados. Olvida las grabaciones: yoga real en vivo por Zoom. Recibe tu link al instante y resetéate con la guía experta de Vimutti. 60 minutos de calma desde tu propia sala.',
      singlePrice: '$1',
      packPrice: '$1',
      packSavings: 'Ahorras $20'
    },
    privada: {
      title: 'Clases Privadas',
      description: 'Yoga diseñado solo para ti. Avanza 3 veces más rápido con atención 1 a 1 y ajustes exactos para tu cuerpo. 60 min de práctica exclusiva para superar tus límites y resetear tu mente a tu propio ritmo.',
      singlePrice: '$1',
      packPrice: '$1',
      packSavings: 'Ahorras $40'
    }
  },
  testimonials: {
    sectionLabel: 'Testimonios',
    sectionTitle: 'Lo que dicen quienes ya practican',
    sectionSubtitle: 'Personas reales, resultados reales. Principiantes y practicantes que encontraron su espacio.',
    items: [{
      quote: '¡Las mejores clases de yoga en Katy! Estaba nerviosa como principiante total, pero la instructora me hizo sentir muy bienvenida. Las sesiones del sábado por la mañana son perfectas para relajarse después de una semana ocupada. ¡Muy recomendado!',
      author: 'Valentina Rodríguez',
      location: 'Katy, TX',
      date: 'hace 2 semanas',
      rating: 5,
      verified: true
    }, {
      quote: 'Llevo 3 meses haciendo las clases virtuales y me sorprende lo conectada que me siento incluso desde casa. El sistema de reservas es súper fácil y los recordatorios me han salvado. ¡Vale cada centavo!',
      author: 'Camila Herrera',
      location: 'Katy, TX',
      date: 'hace 1 mes',
      rating: 5,
      verified: true
    }, {
      quote: 'El paquete mensual tiene un valor increíble. Me encanta tener mi rutina de yoga los domingos - marca el tono para toda mi semana. La instructora es muy conocedora y crea una atmósfera tan pacífica. Ya no puedo imaginar mis fines de semana sin esto.',
      author: 'Alejandra Morales',
      location: 'Katy, TX',
      date: 'hace 3 semanas',
      rating: 5,
      verified: true
    }]
  },
  faq: {
    sectionLabel: 'FAQ',
    sectionTitle: 'Preguntas frecuentes',
    items: [{
      q: '¿Necesito experiencia previa en yoga?',
      a: 'No. Todas las clases están diseñadas para ser accesibles. Al reservar puedes indicar tu nivel y la clase se adapta. Principiantes son bienvenidos siempre.'
    }, {
      q: '¿Qué necesito llevar a la clase presencial?',
      a: 'Ropa cómoda, una botella de agua y, si tienes, tu mat de yoga. Si no tienes mat, puedes avisarnos al reservar y te conseguimos uno prestado (disponibilidad limitada).'
    }, {
      q: '¿Cómo funciona la clase virtual?',
      a: 'Al confirmar tu reserva recibes por email el enlace de Zoom. La clase es en vivo, no grabada. Necesitas conexión a internet y espacio para moverte. La misma guía, la misma clase, desde tu casa.'
    }, {
      q: '¿Puedo cancelar o reprogramar?',
      a: 'Sí. Puedes cancelar con reembolso completo hasta 24 horas antes de la clase. Menos de 24 horas no aplica reembolso, pero puedes reprogramar una vez sin costo adicional.'
    }, {
      q: '¿Cuántos lugares hay por clase?',
      a: "Las clases presenciales tienen cupo limitado (generalmente 8–12 personas) para garantizar atención personalizada. Las virtuales tienen mayor capacidad. Si ves 'pocos lugares', reserva pronto."
    }]
  },
  contact: {
    sectionLabel: 'Contacto',
    sectionTitle: 'Hablemos',
    sectionSubtitle: '¿Tienes preguntas? Estamos aquí para ayudarte',
    email: 'vimuttiyoga@gmail.com',
    phone: '(407) 897-1305',
    whatsapp: '(407) 897-1305',
    hoursWeekday: 'Lunes a Viernes: 9:00 AM - 7:00 PM',
    hoursWeekend: 'Sábados y Domingos: 8:00 AM - 6:00 PM'
  },
  footer: {
    description: 'Clases de yoga de fin de semana para reconectar con tu cuerpo, calmar tu mente y recargar energía para la semana.',
    copyrightText: '© 2025 Vimutti Yoga. Todos los derechos reservados.'
  }
};
interface SiteContentContextType {
  content: SiteContent;
  updateSection: <K extends keyof SiteContent>(section: K, data: SiteContent[K]) => void;
  updateAllContent: (data: SiteContent) => void;
}
const SiteContentContext = createContext<SiteContentContextType | undefined>(undefined);
export function SiteContentProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [content, setContent] = useState<SiteContent>(() => {
    const saved = localStorage.getItem('vimutti_site_content');
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        return {
          ...defaultContent,
          ...parsed,
          hero: {
            ...defaultContent.hero,
            ...(parsed.hero || {})
          },
          about: {
            ...defaultContent.about,
            ...(parsed.about || {})
          },
          classes: {
            ...defaultContent.classes,
            ...(parsed.classes || {}),
            presencial: {
              ...defaultContent.classes.presencial,
              ...(parsed.classes && parsed.classes.presencial || {})
            },
            virtual: {
              ...defaultContent.classes.virtual,
              ...(parsed.classes && parsed.classes.virtual || {})
            },
            privada: {
              ...defaultContent.classes.privada,
              ...(parsed.classes && parsed.classes.privada || {})
            }
          },
          testimonials: {
            ...defaultContent.testimonials,
            ...(parsed.testimonials || {})
          },
          faq: {
            ...defaultContent.faq,
            ...(parsed.faq || {})
          },
          contact: {
            ...defaultContent.contact,
            ...(parsed.contact || {})
          },
          footer: {
            ...defaultContent.footer,
            ...(parsed.footer || {})
          }
        };
      } catch (e) {
        return defaultContent;
      }
    }
    return defaultContent;
  });
  useEffect(() => {
    localStorage.setItem('vimutti_site_content', JSON.stringify(content));
  }, [content]);
  const updateSection = <K extends keyof SiteContent,>(section: K, data: SiteContent[K]) => {
    setContent(prev => ({
      ...prev,
      [section]: data
    }));
  };
  const updateAllContent = (data: SiteContent) => {
    setContent(data);
  };
  return <SiteContentContext.Provider value={{
    content,
    updateSection,
    updateAllContent
  }} data-id="element-1170">
      {children}
    </SiteContentContext.Provider>;
}
export function useSiteContent() {
  const context = useContext(SiteContentContext);
  if (context === undefined) {
    throw new Error('useSiteContent must be used within a SiteContentProvider');
  }
  return context;
}